import React from 'react';
import { Text } from '@components/typography';
import { registryPageData } from '@data-ts/pages/registry';
import { JoykitColor } from '@components/themes';
import { WrapperSlider, ContentSlider } from './PropsSlider.styles';

const registryHeroData = registryPageData.hero;

interface PropsSliderProps {
  eyebrowColor?: JoykitColor;
  textColor?: JoykitColor;
}

export const PropsSlider: React.FC<PropsSliderProps> = ({ eyebrowColor = 'mono7', textColor = 'mono7' }) => {
  return (
    <>
      <Text variant="sectionEyeBrow20" color={eyebrowColor} tagName="h1" textAlign="center" marginBottom={5}>
        {registryHeroData.eyebrow}
      </Text>
      <Text variant="hed72Hero" color={textColor} tagName="span">
        Build your
      </Text>
      <WrapperSlider marginBottom={6}>
        <ContentSlider variant="hed72Hero" color={textColor} tagName="div">
          registry your way.
          <br />
          ultimate kitchen.
          <br />
          cozy living room.
          <br />
          dream honeymoon.
          <br />
          serene bath space.
          <br />
          next adventure.
          <br />
          bedroom sanctuary.
          <br />
          backyard oasis.
          <br />
          life together.
          <br />
          registry your way.
        </ContentSlider>
      </WrapperSlider>
    </>
  );
};
